<template>
  <div class="device-ct">
    <PullDown v-if="!hidePullDown" style="margin-top: 0;"></PullDown>
    <div class="nav">
      <div class="module-title">
        <h1>医学影像诊断思维教学系统</h1>
      </div>

      <div class="ct-content">
        <div class="single-col-card">
          <!-- 文字描述区域，统一标准蓝竖线样式 -->
          <div class="text-wrap">
            <p class="text-content" v-for="(item,index) in p" :key="index">{{item}}</p>
          </div>

          <!-- 全景大图 -->
          <div class="main-banner imgLimit">
            <img
              :src="require('@/assets/pacs.png')"
              alt="医学影像诊断思维教学系统主界面，DICOM阅片病例教学平台"
              class="banner-img"
              loading="lazy"
              decoding="async"
            />
            <div class="banner-glow"></div>
          </div>

          <!-- 功能卡片网格 -->
          <el-row class="hidden-xs-only">
            <el-col :xs="24" :sm="12" :md="8" v-for="(item,index) in card" :key="index">
              <div class="card">
                <h3>{{item.title}}</h3>
                <p>{{item.p}}</p>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PullDown from "@/components/home/pullDown.vue"
export default {
  props: {
    hidePullDown: {
      type: Boolean,
      default: false // 默认显示
    }
  },
  name: "PacsSystem",
  components: {
    PullDown
  },
  data(){
    return{
      wWidth: window.innerWidth,
      p:[
        "本系统以《医学影像诊断学》为理论框架，按人体八大系统分类收集500余种疾病类型、80余万幅图像，典型案例通过检查申请单、影像图像、住院病历、影像报告、病例详解、练习题等模块进行影像诊断思维训练，根据系统章节展示所需掌握的知识点，以思维导图的形式辅助展示重点内容方便记忆学习。学生可不受时间、空间限制进行学习，把虚拟仿真、病例实践与常规教学结合起来，形成虚实结合的教学体系，实现案例式、情景化、信息化教学。"
      ],
      card:[
        {
          title:"影像数据",
          p:"检查技术包括MRI、DR、CT等技术，涵盖几百个人体部位DICOM影像，提供不同部位80万＋图像案例，并不断维护更新。"
        },
        {
          title:"诊断思维",
          p:"通过病例介绍→病例分析→病例报告进行思维训练模式，分类收集建立多种疾病的典型病例和非典型的疑难病例，提供多个真实案例及考题。能更好的让学生全面对各类影像进行阅片练习、报告书写练习。"
        },
        {
          title:"考试中心",
          p:"基于大量试题数据，实现不同难易度在线练习、测评考试，通过练习、考试可及时获取系统中备有较为丰富的图像资源和试题库，方便学生影像诊断与成绩测试。"
        }
      ]
    }
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.wWidth = window.innerWidth;
    }
  }
}
</script>

<style lang="scss" scoped>
// 全局页面统一外层架构
.device-ct {
  width: 100%;
  padding: 1rem;
  margin-top: 80px;
  background: linear-gradient(180deg, #f0f6ff 0%, #ffffff 100%);
  box-sizing: border-box;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;

  @media (max-width: 767px) {
    margin-top: 60px;
    padding: 0.5rem;
  }

  .nav {
    width: 60%;
    margin: 0 auto;
    border: none;
    border-radius: 20px;
    background: rgba(255, 255, 255, 0.85);
    backdrop-filter: blur(10px);
    box-shadow: 0 20px 60px rgba(37, 75, 156, 0.10),
                0 8px 24px rgba(37, 75, 156, 0.06);
    transition: all 0.3s ease;
    overflow: hidden;
    margin-top: 20px;

    @media (max-width: 1024px) {
      width: 80%;
    }
    @media (max-width: 767px) {
      width: 100%;
      border-radius: 16px;
      box-shadow: 0 12px 40px rgba(37, 75, 156, 0.08);
    }

    &:hover {
      box-shadow: 0 24px 72px rgba(37, 75, 156, 0.14);
    }
  }

  .module-title {
    padding: 2.5rem 2rem 1.5rem;
    font-size: 1.75rem;
    font-weight: 700;
    color: #1a365d;
    text-align: center;
    letter-spacing: 0.04em;
    position: relative;
    background: linear-gradient(135deg, #f8faff 0%, #eef4ff 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    flex-wrap: wrap;

    h1 {
      margin: 0;
      font-size: inherit;
      font-weight: inherit;
    }

    @media (max-width: 767px) {
      font-size: 1.25rem;
      padding: 1.5rem 1rem 1rem;
      gap: 8px;
    }

    &::after {
      content: "";
      width: 100px;
      height: 4px;
      background: linear-gradient(90deg, #2563eb, #60a5fa, #2563eb);
      border-radius: 4px;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  .ct-content {
    padding: 2.5rem 3rem 3rem;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    gap: 48px;

    @media (max-width: 1024px) {
      padding: 2rem 2rem 2.5rem;
      gap: 36px;
    }
    @media (max-width: 767px) {
      padding: 1.5rem 1rem 1.5rem;
      gap: 28px;
    }
  }

  .single-col-card {
    background: #fff;
    display: flex;
    flex-direction: column;
    gap: 32px;
    width: 100%;
    margin: auto;
  }

  // 统一全局文字样式（和CT/DR/MRI/VR页面完全一致）
  .text-content {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    font-size: 0.95rem;
    line-height: 2;
    color: #1e293b;
    text-align: justify;
    letter-spacing: 0.01em;
    position: relative;
    padding-left: 1rem;
    border-left: 3px solid transparent;

    @media (max-width: 767px) {
      font-size: 0.85rem;
      line-height: 1.85;
      padding-left: 0.75rem;
    }

    &:first-of-type {
      margin-bottom: 2rem;
      border-left-color: #3b82f6;
      background: linear-gradient(90deg, rgba(59, 130, 246, 0.04) 0%, transparent 100%);
      padding: 0.75rem 1rem 0.75rem 1.5rem;
      border-radius: 0 8px 8px 0;

      @media (max-width: 767px) {
        padding: 0.5rem 0.75rem 0.5rem 1rem;
      }
    }

    &:last-of-type {
      margin-bottom: 2rem;
      border-left-color: #3b82f6;
      background: linear-gradient(90deg, rgba(139, 92, 246, 0.04) 0%, transparent 100%);
      padding: 0.75rem 1rem 0.75rem 1.5rem;
      border-radius: 0 8px 8px 0;

      @media (max-width: 767px) {
        padding: 0.5rem 0.75rem 0.5rem 1rem;
      }
    }
  }

  // 大图统一样式
  .imgLimit.main-banner {
    position: relative;
    border-radius: 14px;
    overflow: hidden;
    box-shadow: 0 8px 30px rgba(26, 75, 140, 0.12);
    max-width: 864px;
    height: auto;
    margin: 0 auto;

    @media only screen and (max-width: 767px){
      max-width: 100%;
      padding-top: 20px;
    }
  }
  .banner-img {
    width: 100%;
    height: auto;
    display: block;
    transition: all 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);
  }
  .main-banner:hover .banner-img {
    transform: scale(1.035);
  }
  .banner-glow {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 45%;
    background: linear-gradient(to top, rgba(26, 75, 140, 0.22), transparent);
    pointer-events: none;
  }

  // 功能卡片保留原有业务样式，微调适配主题
  .card{
    min-height: 16.25rem;
    padding: 24px 21px 30px;
    margin: 24px 12px;
    background: #f8f9fa;
    border: 1px solid #2563af;
    border-radius: 30px;
    transition: all 0.3s ease;
    

    &:hover {
      box-shadow: 0 8px 24px rgba(37, 99, 175, 0.12);
      transform: translateY(-4px);
    }

    h3,p{
      margin: 0;
    }

    h3{
      font-size: 16px;
      margin-bottom: 21px;
      color: #232323;
      font-weight: 600;
    }

    p{
      font-size: 14px;
      line-height: 2.25;
      color: #444;
      text-align: left;
    }
  }
}

// 暗色模式全局适配
@media (prefers-color-scheme: dark) {
  .device-ct {
    background: linear-gradient(180deg, #0f1724 0%, #0a0f1a 100%);

    .nav {
      background: rgba(20, 30, 50, 0.92);
      backdrop-filter: blur(12px);
      box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);

      .module-title {
        color: #93bbfc;
        background: linear-gradient(135deg, #0f1a2e 0%, #162035 100%);
        &::after {
          background: linear-gradient(90deg, #1d4ed8, #60a5fa, #1d4ed8);
        }
      }

      .ct-content {
        background: #0f1a2e;

        .single-col-card {
          background: #142033;
        }
        .text-content {
          color: #c8d6e8;
          &:first-of-type {
            background: linear-gradient(90deg, rgba(59, 130, 246, 0.08) 0%, transparent 100%);
          }
          &:last-of-type {
            background: linear-gradient(90deg, rgba(139, 92, 246, 0.08) 0%, transparent 100%);
          }
        }
        .card {
          background: rgba(37, 99, 175, 0.1);
          border-color: #60a5fa;
          h3 { color: #e2e8f0; }
          p { color: #b0c4de; }
        }
      }
    }
  }
}

// 全局导航穿透样式统一
:deep .global-nav[data-v-5e75b752]{
    background: none;
    border: none;
    box-shadow: none;
    padding: 0 0;
    width: 100%;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
}
:deep .global-nav .nav-item .nav-title.active[data-v-5e75b752]:hover {
  color: #0f3059;
  background: transparent;
}
</style>